enum SavingsAgreementType {
  RBS = 'RBS',
  FIXED_PAYMENTS = 'FIXED_PAYMENTS',
  UNDEFINED = 'UNDEFINED',
}

export default SavingsAgreementType;
